import { render, staticRenderFns } from "./WinchDetail.vue?vue&type=template&id=48cfb5fe"
import script from "./WinchDetail.vue?vue&type=script&lang=js"
export * from "./WinchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports